export const valoresExibidosOffCanvasContratos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export const headersProgBasico = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Ano', width: 5, key: 'componenteAf' },
  { text: 'Trimestre', width: 5, key: 'modalidadeAquisicao' },
  { text: 'Status', width: 8, key: 'statusContrato' },
  { text: 'N Produtos', width: 8, key: 'modalidadeAquisicao' },
  { text: 'Total Solicitado', width: 8, key: 'modalidadeAquisicao' },
  { text: 'Total Aprovado', width: 8, key: 'modalidadeAquisicao' },
  { text: 'Total Entregue', width: 8, key: 'modalidadeAquisicao' },
  { text: '% Entregue', width: 8, key: 'modalidadeAquisicao' },
];

export const headersItensContratos = [
  { text: '', width: 1, key: '' },
  { text: 'Item', width: 2, key: 'id' },
  { text: 'Tipo Cota', width: 10, key: 'itemTipoCota' },
  { text: 'Produto', width: 75, key: 'itemProduto' },
  { text: 'Saldo', width: 10, key: 'saldo' },
];

export const fieldObjectContratos = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
